import { Copy } from "lucide-react";
import { Button } from "./ui/button";
import { useToast } from "./ui/use-toast";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { QrCodeGeradoDto } from "@/dtos/QrCodeGeradoDto";
import { useEffect, useRef, useState } from "react";
import { Input } from "./ui/input";
import { DialogNavegarPosPagamentoPix } from "@/pages/FinalizarCompra/DialogNavegarPosPagamentoPix";
import { DialogNavegarPosPagamentoPixApp } from "@/pages/FinalizarCompra/DialogNavegarPosPagamentoPixApp";

export function QrCodePage() {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { toast } = useToast()
    const { state } = useLocation();
    const [qrCode, setQrCode] = useState<QrCodeGeradoDto>()
    const [exibirDialog, setExibirDialog] = useState(false);
    const [exibirDialogApp, setExibirDialogApp] = useState(false);
    const timerRef = useRef<NodeJS.Timeout | null>(null);
    const [searchParams] = useSearchParams();


    useEffect(() => {
        if (!state) {
            navigate('/compra/titulos');
            return;
        }

        const searchParamOrigem = searchParams.get('origem')

        setQrCode(state);
        setLoading(false);

        timerRef.current = setTimeout(() => {
            if (searchParamOrigem) {
                setExibirDialogApp(true)
            } else {
                setExibirDialog(true);
            }

        }, 1000 * 30)


        return () => {
            if (timerRef.current)
                clearTimeout(timerRef.current)
        }
    }, [])



    return loading ? <>Carregando...</> : (
        <>
            {
                exibirDialog && (
                    <DialogNavegarPosPagamentoPix toggleDialog={() => { setExibirDialog(!exibirDialog) }} exibir={exibirDialog} />
                )
            }

            {
                exibirDialogApp && (
                    <DialogNavegarPosPagamentoPixApp toggleDialog={() => { setExibirDialogApp(!exibirDialogApp) }} exibir={exibirDialogApp} />
                )
            }

            {
                qrCode && (
                    <div className="flex flex-col md:flex-row">
                        <div className="md:w-[70%]">
                            <p className="flex justify-center text-2xl text-primary-foreground">Aguardando Pagamento</p>
                            <p className="flex justify-center text-lg text-primary-foreground">Valor da Compra: {qrCode.Valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
                            <p className="flex justify-center text-lg text-primary-foreground">Tempo de Expiração: 10 minutos</p>

                            <div className="flex justify-center">
                                <img src={(qrCode.QrCode.indexOf('http') < 0 ? "data:image/png;base64, " : '') + qrCode.QrCode} alt="Imagem do QrCode" />
                            </div>
                        </div>
                        <div className="self-center w-full mb-10">
                            <div className="flex flex-col justify-center px-10 gap-3">
                                <Input readOnly value={qrCode.QrCodeText} type="text" />
                                <Button className="self-center gap-2 w-full" onClick={async () => {
                                    await navigator.clipboard.writeText(qrCode.QrCodeText);
                                    toast({
                                        variant: 'success',
                                        description: 'Código copiado com sucesso!',
                                        duration: 3000
                                    })
                                }}><Copy />Copiar Pix Copia e Cola</Button>
                            </div>
                        </div>
                    </div>
                )
            }

        </>
    )
}